import { Component } from '@angular/core';
import { NuxReferralComponent } from './nux-referral.component';

@Component({
	selector: 'sp-nux-referral-success',
	templateUrl: './nux-referral-success.component.html',
	styleUrls: ['./nux-referral.component.scss'],
})
export class NuxReferralSuccessComponent extends NuxReferralComponent {}
